import { render } from "./UCToolbar.vue?vue&type=template&id=13f3ab8f&scoped=true"
import script from "./UCToolbar.vue?vue&type=script&lang=js"
export * from "./UCToolbar.vue?vue&type=script&lang=js"

import "./UCToolbar.vue?vue&type=style&index=0&id=13f3ab8f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f3ab8f"]])

export default __exports__